export const NO_DEPARTMENT_FILTER_VALUE = '__NO_DEPARTMENT__';
export const NO_DEPARTMENT_FILTER_DISPLAY = 'No Department';

export const normalizeDepartmentFilterOptions = (department_filter_options = []) => (
	Array.isArray(department_filter_options)
		? department_filter_options
		: Object.values(department_filter_options || {})
);

export const prependNoDepartmentFilterOption = (department_filter_options = []) => [
	{department_id: NO_DEPARTMENT_FILTER_VALUE, department: NO_DEPARTMENT_FILTER_DISPLAY},
	...normalizeDepartmentFilterOptions(department_filter_options),
];

export const isNoDepartmentFilterValue = (filter_value) => `${filter_value}` === NO_DEPARTMENT_FILTER_VALUE;

export const hasNoDepartmentValues = (department_ids = []) => {
	if(!Array.isArray(department_ids)) return true;

	return department_ids.filter((department_id) => {
		const normalized_department_id = `${department_id || ''}`.trim();
		return normalized_department_id && normalized_department_id !== '0' && normalized_department_id !== 'null' && normalized_department_id !== 'undefined';
	}).length === 0;
};
